








import { Vue, Component } from "@/shared/vuepack";
import Products from "@/employer/components/products/Products.vue";
import MyProgramNavigation from "@/employer/components/myprogram/MyProgramNavigation.vue";

@Component({
  components: {MyProgramNavigation, Products }
})
export default class MyProducts extends Vue {}
